import { _DeliveryOptionsStatusBadgeRoot } from "./DeliveryOptionsStatus.styled";
import Typography from "../../Foundation/Typography/Typography";
import FontIcon from "../../Foundation/FontIcon/FontIcon";
import React from "react";

export interface IDeliveryOptionStatusBadgeProps {
  valid?: boolean;
  modeLabel: string;
  locationLabel: string;
  timeLabel: string;
  search?: boolean;
  searchLabel?: string;
  onClick?: () => void;
  wrapper?: "Navigation" | "Cart";
}
const DeliveryOptionsStatusBadge = ({
  modeLabel,
  locationLabel,
  timeLabel,
  search = false,
  searchLabel = "",
  onClick,
  wrapper = "Navigation",
}: IDeliveryOptionStatusBadgeProps) => {
  return (
    <_DeliveryOptionsStatusBadgeRoot
      {...{
        onClick,
        wrapper,
        className: "delivery-options-status-badge",
        title: modeLabel,
        type: "button",
      }}
    >
      {!search && (
        <Typography as={"span"} color={"beigeBg"}>
          {modeLabel}
        </Typography>
      )}
      {!search && (
        <Typography as={"span"} variant={"body2"} color={"beigeBg"}>
          <FontIcon icon={"clock"} size={16} /> {timeLabel}
        </Typography>
      )}
      <Typography
        as={"span"}
        variant={"body2"}
        color={"champagne"}
        ellipse={true}
        style={{ whiteSpace: "nowrap" }}
      >
        <FontIcon icon={"pin"} size={16} />
        {locationLabel}
      </Typography>
    </_DeliveryOptionsStatusBadgeRoot>
  );
};

export default DeliveryOptionsStatusBadge;
